import React from "react";
import { AdTypes } from "./interfaces";
import "./styles.scss";
export interface Props {
    type?: AdTypes[];
    containerId?: string;
}

export const AdContainer = ({ type, containerId = "" }: Props) => {
    const classNames = type ? type.join(" ") : "";
    return <div className={classNames} id={containerId} />;
};
